import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-movement-petitions-new',
		path: '/admin/movement_petitions/new',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-movement-petitions" */ './index'), {
			exportName: 'MovementPetitions',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
	},
];
